import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom hook to safely get query params from either search or hash (HashRouter support)
 */
const useQueryParams = () => {
  const location = useLocation();

  return useMemo(() => {
    let search = location.search;

    if (!search && location.hash.includes("?")) {
      search = location.hash.substring(location.hash.indexOf("?"));
    }

    return new URLSearchParams(search);
  }, [location]);
};

export default useQueryParams;
